<template><div><h1 id="rfm-dimensionen-positionen" tabindex="-1"><a class="header-anchor" href="#rfm-dimensionen-positionen"><span>RFM-Dimensionen, Positionen</span></a></h1>
<p>RFM-Dimensionen, Positionen — Parametrisierung der Punktetabellen zu den RFM-Dimensionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die die Punktetabellen zu den <RouteLink to="/referenz/refs/ft.refdata.trfmdim.html" title="RFM-Dimensionen">RFM-Dimensionen</RouteLink> parametrisiert.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → RFM-Dimensionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Name</dt>
<dd>Bezeichnung der Dimension</dd>
<dt>von/bis</dt>
<dd>Bereich (Einheit gem. <a class="link" href="ft.refdata.trfmdim.html" title="RFM-Dimensionen">RFM-Dimensionen)</a></dd>
<dt>Punkte</dt>
<dd>zuordnung der Punktezahl</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.rfmadr.html" title="RFM-Anzeige">RFM-Dimensionen anzeigen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.trfmdim.html" title="RFM-Dimensionen">RFM-Dimensionen</RouteLink></p>
</div></template>


